// Status constants for BatterySizingRangeResult to avoid magic strings
export const BATTERY_SIZING_STATUS = {
  Selected: 'selected',
  Feasible: 'feasible',
  Infeasible: 'infeasible',
} as const;
